import { render, staticRenderFns } from "./DeleteAccountLayout.vue?vue&type=template&id=98dd739a&scoped=true&"
var script = {}
import style0 from "./DeleteAccountLayout.vue?vue&type=style&index=0&id=98dd739a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dd739a",
  null
  
)

export default component.exports